import { api } from "@/lib/api";

// Action / violence words (every tense and plural form) highlighted in BFX Action prompts; the server swaps them silently.
let ACTION_RE = /(?<![\w@-])(?:blood[\w-]*|bleed\w*|bled|gore|gory|wound\w*|injur\w*|explo\w+|blast\w*|bomb\w*|fire[sdr]?|firing|flames?|burn\w*|bullets?|gunfire|shoot\w*|guns?|stab\w*|slash\w*|knife|knives|kill\w*|murder\w*|punch\w*|hit|hits|hitting|violen\w+|brutal\w*)(?![\w-])/gi;

api.get("/bfx/action/lexicon").then(({ data }) => {
  if (data?.patterns?.length) ACTION_RE = new RegExp(`(?<![\\w@])(?:${data.patterns.join("|")})(?!\\w)`, "gi");
}).catch(() => {});

export const splitAction = (text) => {
  const out = [];
  let last = 0;
  ACTION_RE.lastIndex = 0;
  text.replace(ACTION_RE, (m, ...rest) => {
    const off = rest[rest.length - 2];
    if (off > last) out.push([text.slice(last, off), false]);
    out.push([m, true]);
    last = off + m.length;
    return m;
  });
  if (last < text.length) out.push([text.slice(last), false]);
  return out;
};
